import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AverageList from "../../components/AverageList/AverageList";
import { useTrainingObjectTypes } from "../../hooks/trainingObjectTypes";
import { useGroupAverages } from "../../hooks/groups";

const GroupAverages = ({ groupId }) => {
  const [trainingObjectType, setTrainingObjectType] = useState("");
  const { t } = useTranslation();
  const {
    trainingObjectTypeOptions,
    isLoading: isLoadingTypes
  } = useTrainingObjectTypes("averages");

  const { groupAverages, isLoading: isLoadingAverages } = useGroupAverages(
    groupId,
    trainingObjectType
  );

  const averages = [
    {
      label: t("administration.group"),
      value: groupAverages ? groupAverages.group_avg : 0
    },
    {
      label: t("administration.company"),
      value: groupAverages ? groupAverages.company_avg : 0
    }
  ];

  return (
    <AverageList
      averages={averages}
      header={t("administration.averages")}
      isLoading={isLoadingTypes || isLoadingAverages}
      filterOptions={trainingObjectTypeOptions}
      filterValue={trainingObjectType}
      onFilterChange={setTrainingObjectType}
      menuWidth={192}
    />
  );
};

export default GroupAverages;
